button.z-link {
  padding: 0;
  border: 0;
  margin: 0;
  background-color: transparent;
}

a.z-link,
button.z-link {
  display: inline-flex;
  cursor: pointer;
  font-family: var(--font-family-sans);
  line-height: inherit;
  text-decoration: none;
}

a.z-link.z-link-icon,
button.z-link.z-link-icon {
  --z-icon-width: 1.125em;
  --z-icon-height: 1.125em;

  align-items: center;
  column-gap: 0.5em;
}

a.z-link.z-link-sb,
button.z-link.z-link-sb {
  font-weight: var(--font-sb);
}

a.z-link.z-link-underline,
button.z-link.z-link-underline {
  text-decoration: underline;
}

a.z-link:hover,
button.z-link:hover,
a.z-link:focus,
button.z-link:focus,
a.z-link:active,
button.z-link:active {
  text-decoration: underline;
}

a.z-link:focus,
button.z-link:focus {
  box-shadow: var(--shadow-focus-primary);
  outline: none;
}

a.z-link.z-link-disabled,
button.z-link.z-link-disabled {
  box-shadow: none;
  color: var(--color-disabled03);
  cursor: default;
  fill: var(--color-disabled03);
  outline: none;
  pointer-events: none;
  text-decoration: none;
}

a.z-link,
button.z-link,
a.z-link.z-link-active,
button.z-link.z-link-active,
a.z-link:hover,
button.z-link:hover,
a.z-link.z-link-active:hover,
button.z-link.z-link-active:hover,
a.z-link:focus,
button.z-link:focus,
a.z-link.z-link-active:focus,
button.z-link.z-link-active:focus,
a.z-link:active,
button.z-link:active,
a.z-link.z-link-active:active,
button.z-link.z-link-active:active,
a.z-link:visited,
button.z-link:visited,
a.z-link.z-link-active:visited,
button.z-link.z-link-active:visited {
  color: var(--color-text-link-default);
  fill: var(--color-text-link-default);
}

a.z-link.z-link-blue,
button.z-link.z-link-blue,
a.z-link.z-link-blue.z-link-active,
button.z-link.z-link-blue.z-link-active {
  color: var(--color-text-link-blue);
  fill: var(--color-text-link-blue);
}

a.z-link.z-link-red,
button.z-link.z-link-red,
a.z-link.z-link-red.z-link-active,
button.z-link.z-link-red.z-link-active {
  color: var(--color-text-link-red);
  fill: var(--color-text-link-red);
}

a.z-link.z-link-inverse,
button.z-link.z-link-inverse,
a.z-link.z-link-inverse.z-link-active,
button.z-link.z-link-inverse.z-link-active {
  color: var(--color-text-link-inverse);
  fill: var(--color-text-link-inverse);
}

a.z-link.z-link-blue:hover,
button.z-link.z-link-blue:hover {
  color: var(--color-text-link-blue-hover);
  fill: var(--color-text-link-blue-hover);
}

a.z-link.z-link-red:hover,
button.z-link.z-link-red:hover {
  color: var(--color-text-link-red-hover);
  fill: var(--color-text-link-red-hover);
}

a.z-link.z-link-inverse:hover,
button.z-link.z-link-inverse:hover {
  color: var(--color-text-link-inverse);
  fill: var(--color-text-link-inverse);
}

a.z-link.z-link-blue:active,
button.z-link.z-link-blue:active,
a.z-link.z-link-blue:focus,
button.z-link.z-link-blue:focus {
  color: var(--color-text-link-blue-active);
  fill: var(--color-text-link-blue-active);
}

a.z-link.z-link-red:active,
button.z-link.z-link-red:active,
a.z-link.z-link-red:focus,
button.z-link.z-link-red:focus {
  color: var(--color-text-link-red-active);
  fill: var(--color-text-link-red-active);
}

a.z-link.z-link-inverse:active,
button.z-link.z-link-inverse:active,
a.z-link.z-link-inverse:focus,
button.z-link.z-link-inverse:focus {
  color: var(--color-text-link-inverse);
  fill: var(--color-text-link-inverse);
}

a.z-link.z-link-blue:visited,
button.z-link.z-link-blue:visited {
  color: var(--color-text-link-blue-visited);
  fill: var(--color-text-link-blue-visited);
}

a.z-link.z-link-red:visited,
button.z-link.z-link-red:visited {
  color: var(--color-text-link-red-visited);
  fill: var(--color-text-link-red-visited);
}

a.z-link.z-link-inverse:visited,
button.z-link.z-link-inverse:visited {
  color: var(--color-text-link-inverse);
  fill: var(--color-text-link-inverse);
}
